import type { PropsWithChildren } from "react";

export const StartPagePresentational = (props: PropsWithChildren<object>) => <>{props.children}</>;
